import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Row, Col } from '@gympass/yoga'

import useHowItWorks from './HowItWorks.state'

import * as Style from '../../Home.style'
import HowItWorksWrapper from './HowItWorks.style'

export default function About() {
  const { howItWorksForEmployees, howItWorksForCompanies } = useHowItWorks()

  return (
    <HowItWorksWrapper>
      <Style.Container>
        <Style.Title>
          <FormattedMessage id="smb_acquisition_home.how_it_works.title" />
        </Style.Title>
        <Style.Subtitle>
          <FormattedMessage id="smb_acquisition_home.how_it_works.subtitle" />
        </Style.Subtitle>

        <Row>
          <Col xxs={12} xl={5}>
            <Style.ListTitle>
              <FormattedMessage id="smb_acquisition_home.how_it_works.benefits.company.title" />
            </Style.ListTitle>
            <Style.ListWrapper divided={false}>
              {howItWorksForCompanies.map((item, index) => (
                <Style.ListItem key={item.id}>
                  <Style.ListItemNumber>{index + 1}</Style.ListItemNumber>
                  <Style.ListItemContent>
                    <Style.ListItemTitle>{item.title}</Style.ListItemTitle>
                    <Style.ListItemDescription>
                      {item.description}
                    </Style.ListItemDescription>
                  </Style.ListItemContent>
                </Style.ListItem>
              ))}
            </Style.ListWrapper>
          </Col>

          <Col xxs={12} xl-start={7} xl={5}>
            <Style.ListTitle>
              <FormattedMessage id="smb_acquisition_home.how_it_works.benefits.employee.title" />
            </Style.ListTitle>
            <Style.ListWrapper divided={false}>
              {howItWorksForEmployees.map((item, index) => (
                <Style.ListItem key={item.id}>
                  <Style.ListItemNumber>{index + 1}</Style.ListItemNumber>
                  <Style.ListItemContent>
                    <Style.ListItemTitle>{item.title}</Style.ListItemTitle>
                    <Style.ListItemDescription
                      dangerouslySetInnerHTML={{ __html: item.description }}
                    />
                  </Style.ListItemContent>
                </Style.ListItem>
              ))}
            </Style.ListWrapper>
          </Col>
        </Row>
      </Style.Container>
    </HowItWorksWrapper>
  )
}
